import styled from 'styled-components';

import { colors, fontFamily } from '../../ui/variables';

export const EmptyListWarningStyle = styled.div`
  .container {
    margin-top: 15px;
    display: flex;
    padding: 0 15% 0 15%;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-height: 360px;
    border-radius: 19px;
    background-color: ${colors.mostlyWhite};

    .first-message {
      font-size: 20px;
      ${fontFamily.sourceSansPro.bold};
      margin-top: 20px;
      margin-bottom: 15px;
    }

    .second-message {
      text-align: center;
    }

    .no-result-image {
      max-width: 500px;
      max-height: 280px;
    }
  }
`;
